// extracted by mini-css-extract-plugin
export default {"slide":"Slider_slide__B3SYm","imgCover":"Slider_imgCover__A04yU"};